module.exports = __webpack_public_path__ + "img/flag.bd8b4a02.svg";